import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { useContext } from "react";
import { CustomizationModalStateContext } from "../CustomizeModal/CustomizationContext";
import { CustomizeModalContent } from "../CustomizeModal/CustomizeModalContent";
import { ItemDetailMainContent } from "./ItemDetailMainContent";
import { useItemDetailDialog } from "./useItemDetailDialog";
import { useItemDetailStyles } from "./useItemDetailStyles";
export const ItemDetailDialog = (props) => {
    const { itemImageUrls, imageBaseUrl, isDialogOpen, setDialogContentMode, closeDialog, nutritionLabelImage, customizeModalProps, conflicts, customizationsOptionsSubtext } = props;
    const { labelImageCanLoad, imageCarouselSettings, handleImageError, handleTabChange } = useItemDetailDialog(isDialogOpen, setDialogContentMode, imageBaseUrl, nutritionLabelImage);
    const { isCustomizeModalOpen, setIsCustomizeModalOpen } = useContext(CustomizationModalStateContext);
    const validImages = (itemImageUrls !== null && itemImageUrls !== void 0 ? itemImageUrls : []).filter(Boolean);
    const hasImages = validImages.length > 0;
    const classes = useItemDetailStyles({ hasImages });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const showCustomizationUI = !!customizeModalProps && isCustomizeModalOpen;
    return (_jsx(Dialog, Object.assign({ className: isMobile ? undefined : classes.itemDetailModal, fullWidth: true, maxWidth: "sm", fullScreen: isMobile, open: isDialogOpen, onClose: () => {
            closeDialog();
            setIsCustomizeModalOpen(false);
        } }, { children: showCustomizationUI ? (_jsx(CustomizeModalContent, Object.assign({}, customizeModalProps, { showBackButton: true, onBackClick: () => {
                setIsCustomizeModalOpen(false);
            }, onClose: () => {
                closeDialog();
                setIsCustomizeModalOpen(false);
            }, conflicts: conflicts, customizationsOptionsSubtext: customizationsOptionsSubtext }))) : (_jsx(ItemDetailMainContent, Object.assign({}, props, { hasImages: hasImages, validImages: validImages, imageCarouselSettings: imageCarouselSettings, handleImageError: handleImageError, handleTabChange: handleTabChange, classes: classes, labelImageCanLoad: labelImageCanLoad }))) })));
};
